import { ref } from "vue"

export const useScreen = () => {
    const screenWidth = ref(window.innerWidth)
    const screenHeight = ref(window.innerHeight)

    window.onresize = () => {
        screenWidth.value = window.innerWidth
        screenHeight.value = window.innerHeight
    }

    return {
        screenHeight, screenWidth
    }
}